// extracted by mini-css-extract-plugin
module.exports = {"building":"MapElements-module__building___1Wiqq","name":"MapElements-module__name___6Ou0Z","dist":"MapElements-module__dist___2PQsx"};